<template>
    <div>
        <el-input v-model="input" size="mini" style="width:110px" placeholder="请输入订单id"></el-input>
        <el-button type="primary" size="mini" icon="el-icon-search" style="margin-left:20px">搜索</el-button>
        <el-card style="margin-top:20px">
            <el-table>
                <el-table-cloumn label="站点"></el-table-cloumn>
                <el-table-cloumn label="站点"></el-table-cloumn>
                <el-table-cloumn label="站点"></el-table-cloumn>
                <el-table-cloumn label="站点"></el-table-cloumn>
                <el-table-cloumn label="站点"></el-table-cloumn>
                <el-table-cloumn label="站点"></el-table-cloumn>
            </el-table>
        </el-card>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                input: ''
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>